import type { track as TrackFn } from "pro-features/components/WithTrack/src/context";
import SignalType from "../../../models/core/SignalType";
import TrafficChangesPeriod from "../../../models/traffic/TrafficChangesPeriod";
import TechnologyChangesPeriod from "app/pages/sales-intelligence/sub-modules/signals/models/technology/TechnologyChangesPeriod";

export default function createSignalsFiltersTrackingService(track: TrackFn) {
    const trackFilterChangeEvent = (action: string, name: string) => {
        track("Drop down", action, name);
    };

    function tractionOptionToTrackingPeriod(option: TrafficChangesPeriod | TechnologyChangesPeriod): string {
        switch (option) {
            case TechnologyChangesPeriod.Quarter:
                return "3 months";
            case TechnologyChangesPeriod.HalfYear:
                return "6 months";
            case TrafficChangesPeriod.MonthOverMonth:
                return "last month";
            case TrafficChangesPeriod.QuoterOverQuoter:
                return "last 3 months";
            case TrafficChangesPeriod.YearOverYear:
                return "last year";
            default:
                return "unknown";
        }
    }

    return {
        trackTractionPeriodChange(filterValue: TrafficChangesPeriod | TechnologyChangesPeriod, signalAlias: string) {
            trackFilterChangeEvent(
                "change time period for signal",
                `${tractionOptionToTrackingPeriod(filterValue)}/${signalAlias}/${SignalType.Traffic}`,
            );
        },
        trackTechnologyFilterChange(filterValue: ReadonlyArray<string>, signalAlias: string) {
            trackFilterChangeEvent("change technology", `${filterValue}/${signalAlias}`);
        },
        trackCountriesFilterChange(filterValue: ReadonlyArray<string>, signalAlias: string, eventSubSubName?: string) {
            trackFilterChangeEvent(
                "change country",
                eventSubSubName ? `${filterValue}/${signalAlias}/${eventSubSubName}` : `${filterValue}/${signalAlias}`,
            );
        },
        trackAdNetworkFilterChange(filterValue: ReadonlyArray<string>, signalAlias: string) {
            trackFilterChangeEvent("change ad network", `${filterValue}/${signalAlias}`);
        },
    };
}
